import { init, Selectors } from '@makemydeal/dr-activities-recent-deals';
import { APP_NAME } from './constants';
import { hostActions } from './hostActions';
import { additionalSelectors } from './additionalSelectors';

let recentDealsSelectors: Selectors;

export const configureRecentDeals = () => {
    const { middlewareMgr, selectors } = init(APP_NAME, additionalSelectors, hostActions);
    recentDealsSelectors = selectors;
    return middlewareMgr;
};

export const getRecentDealsSelectors = (): Selectors => recentDealsSelectors;
